'use client';
import { LuCalendarPlus2 } from 'react-icons/lu';
import { FaFilter, FaRegCommentDots } from 'react-icons/fa6';
import BlogSidebar from '@/features/blog/blog-sidebar/components/BlogSidebar';
import BlogCommentsForm from '@/features/blog/blog-comment-form/components/BlogCommentsForm';
import { FaRegUserCircle } from 'react-icons/fa';
import BlogComments from '../../blog-comment/components/BlogComments';
import Link from 'next/link';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import Preloader from '@/features/preloader/components/Preloader';
import parse from 'html-react-parser';
import NextImage from '@/features/Image';
import { useEffect, useState } from 'react';
import { API_BLOG_SINGLE } from '@/constant/apiRout';

const BlogDetails = ({ slug }: any) => {
  const { data: blog, isLoading } = useFetcherCSR(API_BLOG_SINGLE(slug));
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 992); // MD breakpoint
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // if (isLoading) return <Preloader />;

  return (
    <>
      {/* ================> Page header start here <================== */}
      <section className="page-header section-bg">
        <div className="container">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item ">
                  <Link href="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Blog Details
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      {/* ================> Page header end here <================== */}

      {/* ===============>> Blog details section start here <<================= */}

      <div className="blog-details  padding-bottom section-bg">
        <div className="container">
          {isMobile && !sidebarOpen && (
            <button
              className="floating-filter-btn d-lg-none"
              onClick={() => setSidebarOpen(true)}
            >
              <FaFilter />
            </button>
          )}
          <div className="blog-details__wrapper">
            <div className="row g-5">
              {isLoading ? (
                <div className="col-lg-8" aria-hidden="true">
                  <div className="blog-details__item">
                    <div className="blog-details__item-inner">
                      {/* Add placeholder-glow to the parent for the animation effect */}
                      <div className="placeholder-glow">
                        {/* --- Image Placeholder --- */}
                        <div className="blog-details__thumb">
                          <div
                            className="blog-details__thumb-inner"
                            // Match the dimensions/aspect ratio of the real image
                            style={{
                              height: '620px',
                              backgroundColor: '#e9ecef',
                            }}
                          >
                            <div className="placeholder w-100 h-100"></div>
                          </div>
                        </div>

                        <div className="blog-details__content mt-4">
                          {/* --- Title Placeholder --- */}
                          <h2 className="fw-semibold">
                            <span className="placeholder col-10 placeholder-lg"></span>
                            <span className="placeholder col-7 placeholder-lg"></span>
                          </h2>

                          {/* --- Meta Info Placeholder --- */}
                          <div className="blog-details__meta">
                            <ul>
                              <li>
                                <span className="placeholder col-3"></span>
                              </li>
                              <li>
                                <span className="placeholder col-4"></span>
                              </li>
                              <li>
                                <span className="placeholder col-2"></span>
                              </li>
                            </ul>
                          </div>

                          {/* --- Content/Paragraphs Placeholder --- */}
                          <div className="mb-4">
                            <p>
                              <span className="placeholder col-12"></span>
                              <span className="placeholder col-12"></span>
                              <span className="placeholder col-8"></span>
                            </p>
                            <p>
                              <span className="placeholder col-11"></span>
                              <span className="placeholder col-10"></span>
                            </p>
                            <p>
                              <span className="placeholder col-12"></span>
                              <span className="placeholder col-7"></span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-8">
                  <div className="blog-details__item">
                    <div className="blog-details__item-inner">
                      <div className="blog-details__thumb">
                        <div
                          className="blog-details__thumb-inner"
                          data-aos="fade-up"
                          data-aos-duration={800}
                        >
                          <NextImage
                            width={748}
                            height={320}
                            src={
                              blog?.post?.picture[0]?.url ||
                              '/images/beauty/beauty-home.png'
                            }
                            alt="blog-image"
                          />
                        </div>
                      </div>
                      <div className="blog-details__content">
                        <h2 className="fw-semibold">{blog?.post?.title}</h2>
                        <div className="blog-details__meta">
                          <ul>
                            {blog?.post?.author && (
                              <li>
                                <FaRegUserCircle size={22} />
                                {blog?.post?.author}
                              </li>
                            )}
                            {blog?.post?.date && (
                              <li>
                                <LuCalendarPlus2 size={22} />
                                {blog?.post?.date}
                              </li>
                            )}
                            {blog?.post?.comments > 0 && (
                              <li>
                                <Link href="#">
                                  <FaRegCommentDots size={22} />
                                  {blog?.post?.comments}
                                </Link>
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="mb-0">
                          {blog?.post?.content && parse(blog?.post?.content)}
                        </div>
                      </div>

                      {blog?.post?.comment && <BlogComments />}
                      <BlogCommentsForm blog_id={blog?.id} />
                    </div>
                  </div>
                </div>
              )}

              <div
                className={`col-lg-4 col-md-8 col-12 sidebar-col p-0 ${sidebarOpen ? 'sidebar-mobile-open' : ''}`}
              >
                <BlogSidebar
                  recentPosts={blog?.recentPosts || []}
                  onClose={() => setSidebarOpen(false)}
                  isMobileOpen={sidebarOpen}
                  isLoading={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===============>> Blog details section start here <<================= */}
    </>
  );
};

export default BlogDetails;
